<template>
  <div class="page-box">
    <div class="flex pageNum">
      <span style="color: #5C5D5F;margin-right: 21px">{{getNumber(selectIndex)}}</span>/<span style="margin-left: 21px">{{getNumber(pageIndex)}}</span>

    </div>

    <div class="flex">
      <template v-if="selectIndex==1">
        <img class="btn" style="margin-right: 21px" src="@/assets/imgs/common/left1.png"/>
      </template>
      <template v-else>
        <img class="btn" style="margin-right: 21px" @click="last()" src="@/assets/imgs/common/left.png"/>
      </template>
      <template v-if="selectIndex<pageIndex">
        <img class="btn" src="@/assets/imgs/common/right.png" @click="next()" />
      </template>
      <template v-else>
        <img class="btn" src="@/assets/imgs/common/right1.png"/>
      </template>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    props:['pageIndex',"selectIndex"],
    methods:{
      getNumber(num){
        if(num<10){
          return "0"+num
        }
        return num
      },
      last(){
        if(this.selectIndex!=1){
          this.$emit("last")
        }
      },
      next(){
        if(this.selectIndex<this.pageIndex){
          this.$emit("next")
        }

      }
    }
  }
</script>

<style scoped>
  .page-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    border-bottom:2px solid #5C5D5F;
  }
.pageNum{
  font-size: 28px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #19203B;
}
  .btn{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;

  }
</style>



// WEBPACK FOOTER //
// src/components/page.vue